import React from 'react';

// Dual-thumb price range slider — no external dependency. Two native range
// inputs are overlaid; only their thumbs receive pointer events so both handles
// stay draggable. `value` is a [lo, hi] number pair (rupees); `format` renders
// each end's label. When hi sits at `max` the caller treats it as "and above".
export default function PriceRangeSlider({ min, max, step = 1, value, onChange, format = (v) => v }) {
  const [lo, hi] = value;
  const setLo = (v) => onChange([Math.min(v, hi - step), hi]);
  const setHi = (v) => onChange([lo, Math.max(v, lo + step)]);
  const pct = (v) => Math.max(0, Math.min(100, ((v - min) / (max - min)) * 100));

  return (
    <div className="px-1 pt-1">
      <div className="flex justify-between mb-2 text-xs font-semibold text-gray-800">
        <span>{format(lo)}</span>
        <span>{format(hi)}{hi >= max ? '+' : ''}</span>
      </div>
      <div className="relative h-6 flex items-center">
        {/* rail + selected range */}
        <div className="absolute h-1 w-full rounded-full bg-gray-200" />
        <div
          className="absolute h-1 rounded-full bg-blue-600"
          style={{ left: `${pct(lo)}%`, right: `${100 - pct(hi)}%` }}
        />
        {/* min thumb — lift above when both handles bunch at the top end */}
        <input
          type="range" min={min} max={max} step={step} value={lo}
          onChange={(e) => setLo(Number(e.target.value))}
          className="vv-range" style={{ zIndex: lo >= max - step ? 5 : 3 }}
          aria-label="Minimum price"
        />
        {/* max thumb */}
        <input
          type="range" min={min} max={max} step={step} value={hi}
          onChange={(e) => setHi(Number(e.target.value))}
          className="vv-range" style={{ zIndex: 4 }}
          aria-label="Maximum price"
        />
      </div>
      <style>{`
        .vv-range { position:absolute; left:0; width:100%; margin:0; height:1rem; background:transparent; pointer-events:none; -webkit-appearance:none; appearance:none; }
        .vv-range::-webkit-slider-runnable-track { background:transparent; border:none; }
        .vv-range::-moz-range-track { background:transparent; border:none; }
        .vv-range::-webkit-slider-thumb { -webkit-appearance:none; appearance:none; pointer-events:auto; height:18px; width:18px; border-radius:9999px; background:#2563eb; border:2px solid #fff; box-shadow:0 1px 3px rgba(0,0,0,.35); cursor:pointer; margin-top:-8px; }
        .vv-range::-moz-range-thumb { pointer-events:auto; height:18px; width:18px; border-radius:9999px; background:#2563eb; border:2px solid #fff; box-shadow:0 1px 3px rgba(0,0,0,.35); cursor:pointer; }
      `}</style>
    </div>
  );
}
